/* eslint-disable sonarjs/cognitive-complexity */
export const useFilter = () => {
  const returnMessagesFilters = (item, msgRepetition) => {
    const messages = new Map();

    const messageRepetition = `
    Notamos que a(s) palavra(s) ${msgRepetition} se repete(m) várias vezes.`;
    const messageFirst = 'Não ter sido iniciada com o pronome "Eu".';
    const messagePlagiarized = 'De autoria de terceiros. (Plágio)';

    messages.set('FIRST', messageFirst);
    messages.set('REPETITION', messageRepetition);
    messages.set('PLAGIARIZED', messagePlagiarized);

    return messages.get(item.typeTestSpeck);
  };

  return { returnMessagesFilters };
};
